<template>
  <v-row class="mt-2 mb-2">
    <v-col cols="4" class="pr-2">
      <v-btn class="" variant="outlined" width="100%" @click="saveDraft" :loading="btnDraftLoading" :disabled="disabled">
        <div>
          <div class="captionText">下書きへ</div>
          <div class="text-button font-weight-bold message-btn">保存</div>
        </div>
      </v-btn>
    </v-col>

    <v-col cols="4" class="pl-1 pr-1">
      <v-btn class="" color="primary" variant="outlined" width="100%" @click="saveSendReady" :loading="btnReadyLoading" :disabled="disabled">
        <div>
          <div class="captionText">送信準備BOXへ</div>
          <div class="text-button font-weight-bold message-btn">保存</div>
        </div>
      </v-btn>
    </v-col>

    <v-col cols="4" class="pl-2">
      <v-btn class="" color="primary" variant="flat" width="100%" @click="sendMessage" :loading="btnSendLoading" :disabled="disabled">
        <div>
          <div class="captionText">いますぐ</div>
          <div class="text-button font-weight-bold message-btn">送信</div>
        </div>
      </v-btn>
    </v-col>
  </v-row>
</template>
<script lang="ts">
//import Vue from 'vue';
import { defineComponent } from "vue";
export default defineComponent({

  props: {
    btnSendLoading: {
      type: Boolean,
      default: false
    },
    btnDraftLoading: {
      type: Boolean,
      default: false
    },
    btnReadyLoading: {
      type: Boolean,
      default: false
    },
    inputText: {
      type: String
    },
    isChatCreateUserMe: {
      type: Boolean,
      default: true,
    }
  },

  computed: {
    disabled(): boolean {
      if(this.inputText && this.isChatCreateUserMe) {
        return false
      }
      return true
    }
  },

  methods: {
    saveDraft() {
      this.$emit('saveDraft');
    },
    saveSendReady() {
      this.$emit('saveSendReady');

    },
    sendMessage() {
      this.$emit('sendMessage');

    }
  }
});
</script>
<style lang="scss" scoped>
@use '@/sass/ress.scss' as *;

.message-btn {
  line-height: 1rem;
}
.captionText {
  font-size: 10px;
}
</style>
